module.exports = __webpack_public_path__ + "6c9c8bd4df68d2b52ff38e2778986820.svg";